import { render, staticRenderFns } from "./WorkflowTask.vue?vue&type=template&id=5619d97f&scoped=true"
import script from "./WorkflowTask.vue?vue&type=script&lang=js"
export * from "./WorkflowTask.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTask.vue?vue&type=style&index=0&id=5619d97f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619d97f",
  null
  
)

export default component.exports